import "./WhiteLabelForAgencies.module.css";
import EnterpriseHeader from "@/reusable_sections/Header";
import YourBrandOurGovernance from "./sections/YourBrandOurGovernance";
import WhoItsFor from "./sections/WhoItsFor";
import AgencyBenefits from "./sections/AgencyBenefits";
import HowWhiteLabelWorks from "./sections/HowWhiteLabelWorks";
import RequestAWhiteLabelDemo from "./sections/RequestAWhiteLabelDemo";
import NetworkFooter from "@/reusable_sections/Footer";
export default function WhiteLabelForAgenciesPage() {
  return <div>
      <EnterpriseHeader />
      <YourBrandOurGovernance />
      <WhoItsFor />
      <AgencyBenefits />
      <HowWhiteLabelWorks />
      <RequestAWhiteLabelDemo />
      <NetworkFooter />
    </div>;
}